// extracted by mini-css-extract-plugin
export default {"tasks-tab-view":"TasksTabView_tasks-tab-view__+6ILn"};